import React, {useEffect,useCallback,useState,useMemo} from 'react'
import {DataTable} from 'primereact/datatable';
import {useField} from "formik";
import {
    extract,
    FieldTypes,
    getItemNames,
    isEditingRecord,
    renderValue,
    wrapArray,
    toStyle,
    _isBlank,
    prepCustomFieldRecord,
    tableFieldFilter,
    formatValueWithCustom, tableFieldConfig
} from "../utils";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {Toolbar} from "primereact/toolbar";
import {v4 as uuid} from "uuid";
import _ from 'lodash';
import {useFormPageFieldConfig, useIsOpenControls} from "../../hooks";
import {Column} from "primereact/column";
import {controlsVisible, orderRecords, renderControlButtons} from "../SubForm/common";
import SubForm from "../SubForm";
import {Checkbox} from "primereact/checkbox";
import {confirmPopup, ConfirmPopup} from 'primereact/confirmpopup';
import DisplayRendering from "../DisplayRendering";
import {ObjectUtils} from "primereact/utils";
import PrimeReact from "primereact/api";
import {processControlsWithLookup} from "../AirtableFields/RecordLinks/search.common";
import {useStore} from "../../@redux";
import {storeFormField} from "../../helpers/formPage";


type TableProps = {
    env: string;
    name: string
    form_id: number;
    visible?: OpenControls
    display_as: string
    mode: string
    dialog?: boolean
    value: any[]
    getRecord?: (id:string|any, records?: any[]) => any
    createForm?: () => any
    details: any
    extraConfig: any
    controls?: {more?:any, edit:OpenControls,lookup:OpenControls,create:OpenControls,remove:OpenControls,order:OpenControls}
    recordSearch?: (processSelected: (selected:any[]) => void, options:any)  => any
    onSaveEdit?: (dirty) => void
}
export const Table = ({env, form_id, name, mode = 'manage', visible, controls, display_as, value, getRecord, dialog = false, details, recordSearch, createForm, extraConfig, onSaveEdit}:TableProps) => {
    console.log("Table Options Render", details.field.name)
    const [currRecId, setCurrRecId] = useState("")
    const [convertedFieldValues, setConvertedFieldValues] = useState({})
    const store = useStore()
    const [indexMap, setIndexMap] = useState(null)
    const [filters,setFilters] = useState(null)
    const fieldConfig = useFormPageFieldConfig(details.instance, details.field.id) as any
    const recordMode = isEditingRecord(details.instance) ? 'update' : 'create'
    const [field,meta,helpers] = useField(name)
    // const [tableItems, setTableItems] = useState([])
    const bulkControls = {remove: useIsOpenControls()}
    const [bulkRemovals, setBulkRemovals] = useState({})
    const [viewCell, setViewCell] = useState<null|{details: any,data:any}>( null )
    const allFields = _.get(extraConfig, 'display_fields.fields') || []
    const displayFields = _.filter(allFields, f => _.get(f,'show.list') );
    const primaryField = allFields.find( af => _.get(af, 'location') === 'primary' )
    // useEffect( () => {
    //     setTableItems([...value])
    // }, [JSON.stringify(value)])
    useEffect( () => {
        if(field.value)setCurrRecId("")
        calcIndexMap(field.value)
        setConvertedFieldValues({})
    }, [field.value?.length])
    const onRemoveCancel = useCallback( () => {
        bulkControls.remove.handleToggle()
        setBulkRemovals({})
    }, [bulkRemovals,bulkControls.remove])
    useEffect( () => {
        if(filters === null){
            setFilters(initFilters())
        }
        if(indexMap === null){
            calcIndexMap(field.value)
        }
    }, [])
    const calcIndexMap = useCallback( (list) => {
        const map = []
        if(list) {
            for (let i = 0; i < list.length; i++){
                const item = list[i]
                map.push( item.tableRecordId )
            }
        }
        console.log("**calcIndexMap**", {map,list})
        setIndexMap(map)
    }, [setIndexMap] )

    const orderedValues = useCallback( () => {
        let ordered = []
        if(indexMap) {
            for (let id of indexMap) {
                ordered.push(field.value.find(v => v.tableRecordId === id))
            }
        }
        console.log("**orderedValues**", {indexMap,value:field.value,ordered})
        return ordered
    }, [field.value,indexMap])
    const fieldInternalKey = useCallback( (f) => {
        return `__table__.${f.id}`
    }, [])
    const initFilters = useCallback( () => {
        let init = {}
        for(let df of displayFields){
            const key = fieldInternalKey(df)
            init[key] = tableFieldFilter(df)
        }
        return init
    }, [displayFields])
    const onRemoveBulk = useCallback( () => {
        if(bulkControls.remove.isVisible && !_.isEmpty(bulkRemovals)){
            const newOptions = [...field.value]
            for(let i=field.value.length-1; i>=0; i--){
                let val = field.value[i]
                if(_.has(bulkRemovals,val.tableRecordId)){
                    newOptions.splice(i,1)
                }
            }

            helpers.setValue(Object.values(newOptions))
            setBulkRemovals({})

        }
        bulkControls.remove.handleToggle()
    }, [bulkControls.remove, bulkRemovals] )



    const onLookup = useCallback( () => {
        controls.lookup.handleOpen()
    }, [controls?.lookup])

    const onCreate =  useCallback ( () => {
        controls.create.handleOpen()
    }, [controls?.create])

    const onOrder = useCallback(() => {
        controls.order.handleOpen()
    }, [controls?.order])

    const onBulkEdit = useCallback( () => {
        setCurrRecId("")
        controls.edit.handleOpen()
    }, [controls?.edit])

    const onDisplay = useCallback( () => {

    }, [])

    const onSearch = useCallback( (selected:any[]) => {
        helpers.setValue(wrapArray(selected))
        controls.lookup.handleClose()
    }, [helpers,  controls?.lookup])

    const {controls:controlsDisplay = {}} = extraConfig

    const useConfigForm = {...extraConfig, disableNav: true }
    const permissions = controlsVisible(env === 'record' ? {edit:true,row_edit:false,remove:true} : {}, extraConfig)
    const onCellSelect = (event) => {
        const {cellIndex, rowIndex, field:selField, rowData} = event
        console.log('Cell Selected', event)
        setViewCell({data:rowData, details: {cellIndex,rowIndex,field:selField, selected:true}})
    }
    const onCellUnselect = (event) => {
        setViewCell(null)
    }
    const isCellSelectable = event => {
        console.log("Cell Selectable", event)
        if(event.data?.column?.key?.endsWith('_actions')){
            return false
        }
        const { rowIndex, field:fieldId, rowData } = event.data
        const fieldInfo = displayFields.find( df => df.id === fieldId )
        return !_isBlank(_.get(rowData, fieldInfo?.name))
    }
    const renderViewHeader = useCallback(() => {
        if(viewCell) {
            const {details: fieldDetails} = viewCell
            const {rowIndex, field: fieldId} = fieldDetails
            const fieldInfo = displayFields.find(df => df.id === fieldId)
            if (!fieldInfo) return ''
            console.log('View Header', fieldInfo)
            return fieldInfo.column_header || fieldInfo.name
        }
        return ''
    }, [getRecord,field.value, displayFields, details]);

    const processFieldTableData = useCallback( (fieldInfo, config) => {
        const toVal = renderRecordField(false)
        const key = fieldInternalKey(fieldInfo)

        for(let rec of field.value){
            _.set(rec,key,toVal(rec,{field:fieldInfo}))
        }
    }, [getRecord,field.value, displayFields, details])

    const renderRecordField = useCallback(function doRender(render) {
     return function doInnerRender(rowData, fieldDetails){
         const record = getRecord ? getRecord(rowData) : rowData
         const {rowIndex, field: fieldId, selected = false} = fieldDetails || {}
         const fieldInfo = _.isObject(fieldId) ? fieldId : displayFields.find(df => df.id === fieldId)
         const recEnv = selected ? 'table_dialog' : 'table'
         console.log('***renderRecordField', {rowData, fieldDetails, rowIndex, fieldId, fieldInfo, record})
         if (!fieldInfo) return ''
         const fieldVal = _.get(record, fieldInfo.name)
         if ([FieldTypes.CUSTOM_TEXT, FieldTypes.CUSTOM_FORMULA].includes(fieldInfo.type)) {
             prepCustomFieldRecord(recEnv, details, record, fieldInfo, allFields)
         }
         if (fieldDetails.selected) console.log('Rendering Record Field ON SELECT', rowIndex, rowData, fieldVal, fieldInfo, record, fieldInfo)
         else console.log('Rendering Record Field**', rowIndex, rowData, fieldVal, fieldInfo, record, fieldInfo)
         return render ?
             <DisplayRendering env={recEnv} name={`${details.field.id}_${fieldInfo.id}_${rowIndex}`} value={fieldVal}
                               extraConfig={fieldInfo} details={details} recordData={record}/>
             : formatValueWithCustom(recEnv, fieldVal, {raw:true, ...fieldInfo}, details, record)
     }
     }, [getRecord,field.value, displayFields, details]);
    const colRemoveBulkTop = <Checkbox name={`header_remove`} checked={Object.keys(bulkRemovals).length >= field.value?.length} onChange={ e => {
        let mod = {...bulkRemovals}
        if(e.checked)for(let v of field.value)mod[v.tableRecordId] = true
        else mod = {}
        setBulkRemovals(mod)
    } } />
    const colRemoveBulk = useCallback( (rowData, { rowIndex = -1, field:fieldName = '' } = {}) => {
        return <div style={{paddingLeft: '16px'}}><Checkbox name={`row_${rowIndex}_remove`} checked={_.has(bulkRemovals,rowData[fieldName])} onChange={ e => {
            const mod = {...bulkRemovals}
            if(e.checked) mod[rowData[fieldName]] = true
            else delete mod[rowData[fieldName]]

            setBulkRemovals(mod)
        } } /></div>
    }, [bulkRemovals])
    const colActions = useCallback((rowData, rowOptions) => {
        const { rowIndex, field:fieldName } = rowOptions
        return <div style={{width: '98%'}} className={'flex flex-wrap gap-3 justify-content-end'}>

            {permissions.edit && !permissions.row_edit && <Button className={'flex p-button-info'} onClick={(e) => {
                console.log('Editing Row', {rowData,rowIndex,value:field.value, rowOptions})
                setCurrRecId(rowData.tableRecordId)
                controls.edit.handleOpen()
            }
            } icon="pi pi-pencil" tooltip="Edit" />}
            {permissions.remove && <Button className={'flex p-button-danger'} onClick={(e) => {
                confirmPopup({
                    target: e.currentTarget,
                    message: 'Are you sure you want to proceed?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () =>  {
                        const index = _.findIndex(field.value, {tableRecordId:rowData.tableRecordId})
                        const newOptions = [...field.value]
                        newOptions.splice(index,1)
                        helpers.setValue(Object.values(newOptions))
                    },
                    reject: () => {}
                });
            }
            } icon="pi pi-times" tooltip="Remove" />}
        </div>
    }, [field.value,permissions,controls?.edit])

    const manageHeader = () => {
        if (['manage'].includes(mode)) {
            if(bulkControls.remove.isVisible) {
                return renderControlButtons({
                       cancel: true,
                        remove: true
                    }, {onCancel: onRemoveCancel, onRemove:onRemoveBulk},
                    {
                        ...controlsDisplay,
                        classes: {cancel: `max-w-10rem p-button-raised p-button-outline`, remove: `p-button-success p-button-raised ${_.isEmpty(bulkRemovals) ? 'p-disabled' : ''}`, ...(controlsDisplay?.classes || {} )},
                        labels: {remove: _.isEmpty(bulkRemovals) ? 'Select Records to Remove' : 'Remove Selected', ...(controlsDisplay?.labels || {} )},
                        custom: {remove: {confirm:false}}
                    })
            }

            if(controls?.edit?.isVisible) {
                return <></>
            }
            return renderControlButtons(controlsVisible({
                        lookup: true,
                        create: true,
                        edit: !!field.value?.length && _.get(extraConfig,'permissions.main.allow_bulk_edit'),
                        display: false,
                        order: !!field.value?.length,
                        remove: !!field.value?.length  && _.get(extraConfig,'permissions.main.allow_bulk_remove')
                    }, extraConfig, recordMode), {onLookup, onCreate, onEdit:onBulkEdit, onDisplay, onOrder, onRemove: onRemoveBulk},
                processControlsWithLookup(details, extraConfig, store, {
                        labels: {edit: 'Bulk Edit', remove: 'Bulk Remove', ...(controlsDisplay?.labels || {} )},
                        custom: {remove: {confirm:false}}
                        ,...(controls.more || {})
                    }) )

        }
        return <></>
    }
    const actionCol = () => {
        const items = []
        if(bulkControls.remove.isVisible)return items
        if(!permissions.edit && !permissions.remove)return items
        if(permissions.edit && permissions.row_edit)items.push( (
            <Column rowEditor headerStyle={{ flexGrow: 1, flexBasis: '100px' }} bodyStyle={{ flexGrow: 1, flexBasis: '100px', padding: '0px', textAlign: 'center' }} />
        ) )
        if(permissions.remove || (permissions.edit && !permissions.row_edit))items.push( (
            <Column
                key={`${name}_actions`}
                header={_.get(extraConfig, 'actionColHeader','')}
                headerStyle={{ flexGrow: 1, flexBasis: '100px',textAlign: 'right' }}
                headerClassName={'flex justify-content-end'}
                bodyStyle={{ flexGrow: 1, flexBasis: '100px',padding: '0px', textAlign: 'right' }}
                body={colActions}
                frozen
                alignFrozen="right"
            /> ) )
        return items
    }



    const renderTable = () => {
        const {plural} = getItemNames(extraConfig,'Linked Record')
        const overrideTableOptions = _.get(extraConfig, 'table',{})
        const rowHeight = _.get(overrideTableOptions,'rowHeight', 150)
        const tableOptions = {...extract({scrollable: true, emptyMessage: `No ${plural}`, className: "editable-cells-table",
            header: undefined, footer: undefined,  tableClassName: undefined,
            paginator: true, paginatorPosition: undefined, alwaysShowPaginator: false, paginatorClassName: undefined,
            paginatorTemplate: undefined, pageLinkSize: undefined, rowsPerPageOptions: undefined, currentPageReportTemplate: undefined,
            first: undefined, rows: 10, totalRecords: undefined, sortField: undefined, sortOrder: undefined, multiSortMeta: undefined,
            sortMode: undefined, defaultSortOrder: undefined, removableSort: undefined, selectionMode: 'single', cellSelection: true, dragSelection: undefined, selection: undefined,
            contextMenuSelection: undefined, compareSelectionBy: undefined, dataKey: 'tableRecordId', metaKeySelection: undefined,
            selectionPageOnly: undefined, selectionAutoFocus: undefined, selectOnEdit: undefined, expandedRows: undefined,
            resizableColumns: undefined, columnResizeMode: undefined, reorderableColumns: undefined,
            globalFilter: undefined, filterDelay: undefined, filterLocale: undefined, scrollHeight: undefined, scrollDirection: 'both',
            frozenWidth: undefined, frozenValue: undefined, csvSeparator: undefined, exportFilename: undefined, rowGroupMode: undefined,
            autoLayout: undefined, loading: undefined, loadingIcon: undefined, tabIndex: undefined, editMode: undefined,
            stateKey: undefined, stateStorage: undefined, editingRows: undefined, expandableRowGroups: undefined, rowHover: undefined,
            showGridlines: undefined, stripedRows: undefined, size: undefined, responsiveLayout: undefined, breakpoint: undefined,
            filterDisplay: undefined, expandedRowIcon: undefined, collapsedRowIcon: undefined, globalFilterFields: undefined,

        }, overrideTableOptions)}
        console.log("**Table Options**", {name:details.field.name, overrideTableOptions, tableOptions, filters,displayFields,value:field.value})
        return (
            <>
                {manageHeader()}
                <Dialog onHide={() => setViewCell(null)} visible={!!viewCell} closable={true} closeOnEscape={true} style={{width: '85vw'}} header={renderViewHeader()} >
                    {viewCell ? renderRecordField(true)(viewCell.data, viewCell.details) : ''}

                </Dialog>
                <DataTable
                  value={field.value}
                  onValueChange={changed => {
                      console.log('**Table Value Change', changed)
                      calcIndexMap(changed)
                  }}
                  // onSort={ sorted => {
                  //     console.log('**Table On Sort', sorted)
                  // } }
                  // onFilter={ items => {
                  //     console.log('**Table On Filter**', {items})
                  // } }
                  filters={filters}
                  onCellSelect={onCellSelect} onCellUnselect={onCellUnselect}
                  isDataSelectable={isCellSelectable}
                  // editMode={permissions.row_edit ? 'row' : 'cell'}
                  // onRowEditInit={onRowEditInit}
                  // onRowEditCancel={onRowEditCancel}
                  {...tableOptions}
                  style={toStyle(_.get(overrideTableOptions,'style',''), {})}
                  tableStyle={toStyle(_.get(overrideTableOptions,'tableStyle',''), {})}
                >
                 {permissions.remove && bulkControls.remove.isVisible &&  (
                        <Column field={'tableRecordId'} headerStyle={{ width: '5rem' }} bodyStyle={{ padding: '0px', textAlign: 'center' }} header={colRemoveBulkTop} body={colRemoveBulk} />
                  )}
                  {displayFields.map((e) => {
                    const { id = '', title:fieldTitle, name: fieldName = '', type = '', column_header: columnHeader } = e;
                    const useFieldName = fieldTitle || fieldName
                    const title = columnHeader || useFieldName
                    const colConfig = {...(_.get(extraConfig, 'table.columns', {})), ...(_.get(e, 'table.columns', {}))}
                    const fieldColInfo = tableFieldConfig(e,colConfig)
                    const canFilter = fieldColInfo.filter
                    const canSort = fieldColInfo.sortable
                    const internalKey = fieldInternalKey(e)
                    if(canSort || canFilter)processFieldTableData(e,fieldColInfo)

                    const fieldOptions = extract({
                        columnKey: e.id, field: e.id,
                        sortField: internalKey, filterField: internalKey,  exportField: internalKey,  footer: undefined,
                          sortableDisabled: undefined, ...fieldColInfo,
                          filterPlaceholder: undefined,  filterMaxlength: undefined,
                        excludeGlobalFilter: undefined,  filterHeaderClassName: undefined,
                        showFilterMenu: undefined, showFilterOperator: undefined,  showClearButton: undefined,
                        showApplyButton: undefined,  showFilterMatchModes: undefined,  showFilterMenuOptions: undefined,
                        showAddButton: undefined,  filterMatchModeOptions: undefined,  maxConstraints: undefined,
                        filterMenuClassName: undefined,   align: undefined,  alignHeader: undefined,  alignFrozen: undefined,
                        hidden: undefined, className: undefined,  headerClassName: undefined,
                          bodyClassName: undefined,  footerClassName: undefined,
                        expander: undefined,  frozen: undefined, selectionMode: undefined,  colSpan: undefined,  rowSpan: undefined,
                        cellEditValidatorEvent: undefined, rowReorder: undefined,  rowReorderIcon: undefined,  rowEditor: undefined,
                        exportable: undefined, reorderable: undefined, resizeable: undefined
                    }, colConfig)

                      const fieldInfo = storeFormField(store, details.path, e.id || e.name)
                      const minWidth = _.get(colConfig, 'minWidth', type === FieldTypes.FT_ATTACHMENTS ? '200px' : '120px')
                      const width = _.get(colConfig, 'width', minWidth)
                    console.log("Field Options",title, e.id,e.name, fieldOptions, e, colConfig, extraConfig, fieldInfo,fieldColInfo, details.path)
                    const style = (path, defaults = {}, overrides = {}) => toStyle( _.get(colConfig,path,''),defaults, overrides)
                    // const fieldValFunc = tableFieldValFunc(e,convertedFieldValues,setConvertedFieldValues,item => renderRecordField(false)(item, {field:id}))

                      return (
                      <Column
                        key={`${name}_${id}`}
                        header={ title}
                        body={renderRecordField(true)}
                        // sortFunction={tableFieldSortFunc(fieldValFunc)}
                        // filterFunction={tableFieldFilterFunc(fieldValFunc)}
                        {...fieldOptions}
                        // onFilterApplyClick={ event => {
                        //     console.log('**Table On Filter Click**', {event})
                        // } }
                        // onFilterClear={ () => {
                        //     console.log('**Table On Filter Clear**')
                        // } }
                        filter={canFilter}
                        sortable={canSort}

                        headerStyle={style('headerStyle', {textAlign: 'center'} )}
                        style={ style('style', {overflow: 'hidden', overflowWrap:'anywhere', flexGrow: 1, minWidth, flexBasis: width})}
                        filterHeaderStyle={style('filterHeaderStyle')}
                        filterMenuStyle={style('filterMenuStyle')}
                        bodyStyle={style('bodyStyle', {maxHeight: `${rowHeight}px`})}
                        footerStyle={style('footerStyle')}
                          // editor={(colProps) => cellEditorTemplate(colProps, type, e)}
                        // onCellEditInit={onEditorInit}
                        // onCellEditCancel={onEditorCancel}
                      />
                    );
                  })}
                    {actionCol()}
                </DataTable>
                {recordSearch ? recordSearch(onSearch, {hideInitSelected: false}) : ''}
                {createForm ? createForm() : ''}
                {orderRecords(field.value, controls?.order, extraConfig,(newItems) => helpers.setValue(newItems))}
                {controls?.edit?.isVisible ? <SubForm onClose={onSaveEdit} form_id={form_id} name={name} initId={currRecId} visible={controls?.edit} mode={'edit'} getRecord={getRecord} primaryField={primaryField} dialog={true} display_as={'navigator'} controls={controls} value={orderedValues()} details={details} extraConfig={useConfigForm} recordSearch={recordSearch}/> : ''}
                <ConfirmPopup />

            </>
        )
    }

    const inner = renderTable()
    if(dialog){
        return (
            <Dialog breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '50vw', height: '85vh'}} onHide={() => visible.handleClose()} visible={visible?.isVisible} closable={false} draggable={false}
                    footer={(
                        <Button onClick={() => visible.handleClose()} label={'DONE'}/>
                    )} header={'Manage Records'}
            >{inner}</Dialog>
        )
    }
    return inner
}

export default Table
